<template lang="pug">
v-dialog(:value="value" @input="$emit('input', $event)" max-width="600")
  v-card
    v-card-title Edit Item (Row {{ itemIndex + 1 }})
    v-card-text
      v-alert(type="warning" dense outlined class="mb-4")
        | Fields containing spreadsheet formulas will be replaced with their current value if edited here.
      v-text-field(
        v-for="(header, i) in headers"
        :key="header"
        :label="header"
        v-model="editedValues[i]"
        outlined
        dense
      )
    v-card-actions
      v-spacer
      v-btn(text @click="cancel") Cancel
      v-btn(color="primary" :loading="saving" @click="save") Save
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    value: Boolean,
    component: { required: true },
    itemIndex: { required: true }
  },

  data() {
    return {
      editedValues: [],
      saving: false
    }
  },

  computed: {
    ...mapGetters(['worksheetPropertyNames', 'worksheetPropertyValues', 'findSpreadsheetWorksheet']),

    headers() {
      return this.worksheetPropertyNames(this.component.spreadsheetId, this.component.worksheetId)
    },

    currentRowValues() {
      const rows = this.worksheetPropertyValues(this.component.spreadsheetId, this.component.worksheetId)
      return rows[this.itemIndex - 1] || []
    },

    worksheetTitle() {
      const ws = this.findSpreadsheetWorksheet(this.component.spreadsheetId, this.component.worksheetId)
      return ws ? ws.title : ''
    }
  },

  watch: {
    value(open) {
      if(open) this.resetValues()
    },
    itemIndex() {
      if(this.value) this.resetValues()
    }
  },

  methods: {
    ...mapActions(['googleUpdateSheetRow', 'refreshSheetIndex']),

    resetValues() {
      this.editedValues = [...this.currentRowValues]
    },

    cancel() {
      this.$emit('input', false)
    },

    async save() {
      this.saving = true
      try {
        await this.googleUpdateSheetRow({
          spreadsheetId: this.component.spreadsheetId,
          worksheetTitle: this.worksheetTitle,
          rowNumber: this.itemIndex + 1,
          values: this.editedValues
        })
        await this.refreshSheetIndex(this.component.spreadsheetId)
        this.$emit('input', false)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
